(function () {
  // selectors
  var CHECKBOX_SEL = '#lc_terms';
  var ATC_BTN_SEL = 'form[action*="/cart/add"] button[name="add"], form[action*="/cart/add"] [type="submit"][name="add"], .product-form__submit';
  var FORM_SEL = 'form[action*="/cart/add"]';
  var DYNAMIC_WRAP_SEL = '.shopify-payment-button';

  function findAll(scope, sel) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel) || []); }
  function q(scope, sel) { return (scope || document).querySelector(sel); }

  function showError() {
    var el = q(document, '#lc_terms_error');
    if (el) el.style.display = 'block';
  }

  function hideError() {
    var el = q(document, '#lc_terms_error');
    if (el) el.style.display = 'none';
  }

  function currentAgree() {
    var cb = q(document, CHECKBOX_SEL);
    return !!(cb && cb.checked);
  }

  function setState(scope) {
    var ok = currentAgree();
    findAll(scope, FORM_SEL).forEach(function (form) {
      var btn = q(form, ATC_BTN_SEL);
      var dyn = q(form.closest('product-form') || form, DYNAMIC_WRAP_SEL);
      if (btn) btn.disabled = !ok;
      if (dyn) {
        dyn.style.pointerEvents = ok ? '' : 'none';
        dyn.style.opacity = ok ? '' : '.5';
      }
    });
  }

  function wireFormGuards(scope) {
    // Guard form submit
    findAll(scope, FORM_SEL).forEach(function (form) {
      if (form.__lcGuarded) return;
      form.addEventListener('submit', function (e) {
        if (!currentAgree()) {
          e.preventDefault();
          showError();
          setState(scope);
          return false;
        }
        // Optional: analytics
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'terms_agreed_pdp' });
        hideError();
        return true;
      });
      form.__lcGuarded = true;
    });

    // Guard direct button clicks (in case apps bypass submit)
    findAll(scope, ATC_BTN_SEL).forEach(function (btn) {
      if (btn.__lcGuardedClick) return;
      btn.addEventListener('click', function (e) {
        if (!currentAgree()) {
          e.preventDefault();
          showError();
          setState(scope);
          return false;
        }
      }, true);
      btn.__lcGuardedClick = true;
    });

    // Initial visual state
    setState(scope);
  }

  function wireCheckbox() {
    var cb = q(document, CHECKBOX_SEL);
    if (!cb || cb.__lcWired) return;
    cb.addEventListener('change', function () {
      hideError();
      setState(document);
    });
    cb.__lcWired = true;
  }

  function boot(scope) {
    wireCheckbox();
    wireFormGuards(scope || document);
  }

  // Initial load
  document.addEventListener('DOMContentLoaded', function () { boot(document); });

  // Handle Dawn section re-renders and quick add
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:reorder', function (e) { boot(e.target); });

  // MutationObserver fallback for dynamic DOM changes
  var mo = new MutationObserver(function () { boot(document); });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
